(function() {
	'use strict';

	angular.module('pretor.online.core', [ 'ui.bootstrap', 'ngSanitize', 'slick' ]);
})();
